module.exports = __webpack_public_path__ + "img/0Q3A7268_L_Black.d26d0459.jpg";